import { Grow, MenuItem, Typography } from '@material-ui/core'
import DoneIcon from '@material-ui/icons/Done'

import { getTranslate } from '../../../localization'
import { MenuItemInInventory } from '../../../types/inventory'
import useStyles from './styles/MenuModal.styles'

interface MenuModalProps {
  items: MenuItemInInventory[]
  onChangeSelectedItem?: (fieldType: MenuItemInInventory) => void
  activeItem: string
  setmenuModalIsOpen: (v: boolean) => void
}

const MenuModal = ({
  activeItem,
  items,
  onChangeSelectedItem,
  setmenuModalIsOpen
}: MenuModalProps) => {
  const classes = useStyles()
  const handleChangeMenuItem = (selectedItem: MenuItemInInventory) => {
    onChangeSelectedItem?.(selectedItem)
    setmenuModalIsOpen(false)
  }
  return (
    <Grow in>
      <div className={classes.root}>
        <div className={classes.selectBoxes}>
          <div className={classes.oneBoxInRow}>
            <div className={classes.ButtonsContainer}>
              <Typography className={classes.typographyOfTitle} variant="h1">
                {getTranslate('Views')}
              </Typography>
            </div>
            {items.map((mItem) => {
              return (
                <div className={classes.menuItemRow}>
                  {activeItem === mItem.code ? <DoneIcon /> : null}
                  <MenuItem
                    key={mItem.code}
                    value={mItem.code}
                    onClick={() => handleChangeMenuItem(mItem)}>
                    {getTranslate(mItem.label)}
                  </MenuItem>{' '}
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </Grow>
  )
}

export default MenuModal
